module.exports = __webpack_public_path__ + "static/media/maestro.c6481359.svg";